var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 
    'background': !_vm.isSimulation, 
    'background-simulation': _vm.isSimulation 
  },style:({ 'border-radius': _vm.isSimulation ? _vm.borderRadius : 0 })},[_c('v-carousel',{style:({
      'border-radius': _vm.isSimulation ? _vm.borderRadius : 0,
      'height': _vm.isMenu ? 'calc(90vh)' : '100%',
      'background-color': _vm.BGColor
    }),attrs:{"continuous":"","cycle":!_vm.isSimulation,"hide-delimiters":"","show-arrows":false,"height":"100%"}},_vm._l((_vm.Carousel),function(item,i){return _c('v-carousel-item',{key:i,staticStyle:{"height":"100%"},attrs:{"src":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }